import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";

/**
 * Guards any nested `/admin/*` route.
 *  - While the /me call is in flight we show a minimal loading panel
 *    (no layout jump, no blank flash).
 *  - Unauthenticated → redirect to /admin/login, remembering where we came
 *    from so we can return there after sign-in.
 */
export default function AdminProtectedRoute() {
  const { status } = useAdminAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-white"
        data-testid="admin-protected-loading"
      >
        <div className="text-sm text-[color:var(--sas-ink-2)]">Checking admin session…</div>
      </div>
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
